<div [ngClass]="{'hidden': !showLoader}" class="loaderWrapper" *ngIf="viewInit">
	<ng-container [ngSwitch]="activeBranding">

		<!-- Deutsche Fiskal -->
		<ng-container
			*ngSwitchCase="brandEnum.DeutscheFiskal"
			[ngTemplateOutlet]="deutscheFiskalLoaderTpl"
		></ng-container>

		<!-- Template	-->
<!--		<ng-container-->
<!--			*ngSwitchCase="brandEnum.Template"-->
<!--			[ngTemplateOutlet]="templateLoaderTpl"-->
<!--		></ng-container>-->

		<!-- Default -->
		<ng-container
			*ngSwitchDefault
			[ngTemplateOutlet]="deutscheFiskalLoaderTpl"
		></ng-container>

	</ng-container>
</div>


<!-- ######################### TEMPLATES ######################### -->

<!-- Deutsche Fiskal -->
<ng-template #deutscheFiskalLoaderTpl>
	<svg xmlns="http://www.w3.org/2000/svg"
			 [attr.width]="svgWidth"
			 [attr.height]="svgHeight"
			 [attr.viewBox]="'0 0 ' + svgWidth + ' ' + svgHeight"
			 class="{{ svgClass }}"
			 [ngClass]="size">
		<g id="df_icon">
			<path [attr.fill]="defaultColor"
						d="M30.1,8.4H20.8V23.6h4V17.8h4.3V14.9H24.8V11.2h4.9ZM5.9,11.3h1c2,0,3.3.9,3.3,4.7,0,3.7-1.2,4.8-3.3,4.8h-1Zm.5-2.9H1.9V23.6H6.8c4,0,7.7-1.6,7.7-7.7-.1-6.2-4-7.5-8.1-7.5"
			/>

			<!-- Top Row	-->
			<rect *ngFor="let itm of rectsData; let idx = index"
						[attr.width]="rectWidth" [attr.height]="rectHeight"
						[attr.transform]="'translate(' + (idx * (rectWidth + rectGapSpace)) + ')'"
						[attr.fill]="defaultColor">
				<animate
					[attr.attributeName]="attribute"
					[attr.begin]="begin"
					[attr.dur]="duration"
					[attr.repeatCount]="repeatCount"
					[attr.values]="itm"
				/>
			</rect>

			<!-- Bottom Row	-->
			<rect *ngFor="let itm of rectsData.reverse(); let idx = index"
						[attr.width]="rectWidth" [attr.height]="rectHeight"
						[attr.transform]="'translate(' + (idx * (rectWidth + rectGapSpace)) + ' 28.4)'"
						[attr.fill]="defaultColor">
				<animate
					[attr.attributeName]="attribute"
					[attr.begin]="begin"
					[attr.dur]="duration"
					[attr.repeatCount]="repeatCount"
					[attr.values]="itm"
				/>
			</rect>
		</g>
	</svg>
</ng-template>

<!-- Template	-->
<!--<ng-template #templateLoaderTpl>-->
<!--	<svg xmlns="http://www.w3.org/2000/svg"-->
<!--			 [attr.width]="38"-->
<!--			 [attr.height]="38"-->
<!--			 [attr.viewBox]="'0 0 ' + 38 + ' ' + 38"-->
<!--			 [attr.stroke]="'#009EE3'"-->
<!--			 class="{{ svgClass }}"-->
<!--			 [ngClass]="size">-->
<!--	</svg>-->
<!--</ng-template>-->
